import * as React from "react";
import { FilterButton } from "@grandvisionhq/common";
import { Heading } from "@grandvisionhq/elements";
import { useIntl, useFeatureToggles } from "@grandvisionhq/state";
import { orderStoreFilters } from "./order-store-filters.js";
/* empty css                  */
const COUNT_LIMIT = 30;
const FILTERS_ORDER = ["opening_times", "services", "accessibility"];
const StoreFilters = ({
  filters,
  appliedFilters,
  toggleFilter,
  isLoadingResults
}) => {
  const { getLabel } = useIntl();
  const { featureConfigs } = useFeatureToggles();
  const maxSearchStoresResults = featureConfigs?.maxSearchStoresResults !== void 0 ? featureConfigs.maxSearchStoresResults : COUNT_LIMIT;
  const orderedFilters = React.useMemo(() => orderStoreFilters(filters, FILTERS_ORDER), [filters]);
  return /* @__PURE__ */ React.createElement("div", { className: "store-filters__container" }, orderedFilters.map(({ name: filterKey, options }) => /* @__PURE__ */ React.createElement("div", { key: filterKey, className: "store-filters__section" }, /* @__PURE__ */ React.createElement(Heading, { variant: "subheading1", className: "store-filters__section-title" }, getLabel(`stores.storeFilters.filters.${filterKey}`)), /* @__PURE__ */ React.createElement("div", { className: "store-filters__filters" }, options.map(({ name: optionKey, count }) => {
    const isFilterSelected = !!appliedFilters[filterKey]?.find(
      (option) => option === optionKey
    );
    const optionName = getLabel(`stores.storeFilters.filters.${filterKey}.${optionKey}`);
    const filterLabelCount = isLoadingResults ? "" : count && count < maxSearchStoresResults || count === 0 ? `(${count})` : `(${maxSearchStoresResults})`;
    const filterLabel = isFilterSelected ? optionName : `${optionName} ${filterLabelCount}`;
    return /* @__PURE__ */ React.createElement(
      FilterButton,
      {
        key: optionName,
        caption: filterLabel,
        icon: isFilterSelected ? "clear" : void 0,
        isSelected: isFilterSelected,
        onClick: () => toggleFilter(filterKey, optionKey)
      }
    );
  })))));
};
export {
  StoreFilters as default
};
//# sourceMappingURL=StoreFilters.js.map
